import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { NgIcon } from '@ng-icons/core';
import { Select, Tab, TabGroup } from 'excellence-ui';
import { HasRoleDirective } from '../../../../shared/directives/has-role';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-parse-requests-details-nav',
  imports: [
    RouterLink,
    RouterLinkActive,
    TabGroup,
    Tab,
    NgIcon,
    Select,
    HasRoleDirective,
    TranslocoPipe,
  ],
  templateUrl: './parse-requests-details-nav.html',
})
export class ParseRequestsDetailsNav {
  private activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);

  protected onSelectChange(url: string | string[] | null): void {
    this.router.navigate([url], {
      relativeTo: this.activatedRoute,
    });
  }
}
